import { Link } from "react-router-dom";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";
import AreaMap from "../AreaMap";
import { useLang } from "../../i18n";

const Area = () => {
    const { t } = useLang();
    return (
        <section data-testid="area-section" className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
            <div className="grid items-center gap-12 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <SectionHead
                        eyebrow={t.areaHome.eyebrow}
                        title={t.areaHome.title}
                        sub={t.areaHome.sub}
                        testid="area-title"
                    />
                    <Reveal delay={0.15}>
                        <p className="mt-5 text-base leading-relaxed text-[#525B53]">
                            {t.areaHome.p}
                        </p>
                        <Link
                            to="/zona-de-servicio"
                            data-testid="area-cta-link"
                            className="mt-7 inline-flex items-center gap-2 rounded-full border border-olive/40 bg-olive-light/50 px-6 py-3 text-sm font-bold text-olive-dark transition-[background-color,transform] duration-200 hover:bg-olive-light hover:-translate-y-0.5"
                        >
                            {t.areaHome.cta}
                        </Link>
                    </Reveal>
                </div>
                <Reveal delay={0.1} className="lg:col-span-7">
                    <AreaMap />
                </Reveal>
            </div>
        </section>
    );
};

export default Area;
